import React, { FC, useMemo, memo } from 'react'
import { Button, Dropdown } from '@wmgtech/legato'

import { relativeDay } from 'shared/utils/formatDate'

import { AddedCommentProps } from './Comment.props'

import styles from './Comment.module.scss'

const AddedComment: FC<AddedCommentProps> = memo(({ onSelectAction, comment, labelsList, canManage }) => {
  const date = useMemo(() => relativeDay(comment.updated_at), [comment.updated_at])

  const name = useMemo(() => `${comment?.author?.first_name || ''} ${comment?.author?.last_name || ''}`, [comment?.author])
  const labelName = useMemo(
    () => labelsList.find((label) => label.id === comment?.author?.label_id),
    [labelsList, comment]
  )

  return (
    <>
      <div className={styles.commentTop}>
        <div className={styles.commentTopTitle}>
          <b>{labelName?.name} </b> {date} | {name}
        </div>
        <div>
          {
            canManage && (
              <Dropdown
                list={[
                  {
                    key: 'edit',
                    title: 'Edit Comment'
                  },
                  {
                    key: 'delete',
                    title: 'Delete Comment'
                  }
                ]}
                onSelect={onSelectAction}
              >
                <Button
                  className={styles.commentTopMenu}
                  icon="ellipsis"
                  colorType="secondary-black"
                  containerStyle="link"
                  size="md"
                />
              </Dropdown>
            )
          }
        </div>
      </div>
      <div className={styles.commentBody}>{comment?.text}</div>
    </>
  )
})

export default AddedComment
